import {rule} from '@/util/validateRules'
import {getStore} from '@/util/store'
import {changeCodeDicEndorseData} from '@/const/crud/settlement/product'
/*
 *  保单列表页
 */
//  当前账号产生的保单列表
export const policyListOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	align: 'center',
	searchLabelWidth: 100,
	menuWidth: 160,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	excelBtn: true,
	rowKey: 'orderId',
	showSummary: true,

	column: [
		{
			label: '产品名称',
			prop: 'insureTypes',
			type: 'select',
			dicData: getStore({name: 'insureTypes'}),
			props: {
				label: 'name',
				value: 'type',
			},
			hide: true,
			search: true,
		},
		{
			label: '被保企业',
			prop: 'insured',
			span: 12,
			fixed: true,
			search: true,
		},
		{
			label: '保单号',
			prop: 'policyNo',
			span: 12,
			fixed: true,
			search: true,
			hide: false,
		},
		{
			label: '保障人员',
			prop: 'empInfo',
			hide: true,
			search: true,
		},
		{
			label: '产品名称',
			prop: 'productName',
			span: 12,
		},
		{
			label: '总保费(元)',
			prop: 'totalMoney',
			width: 120,
		},
		{
			label: '操作人',
			prop: 'distAccountName',
			width: 120,
		},
		{
			label: '保险起期',
			prop: 'startDate',
			type: 'datetime',
			format: 'yyyy-MM-dd 00:00:00',
			valueFormat: 'yyyy-MM-dd 00:00:00',
			// formatter: (val) => {
			// 	return val.startDate + ' 00:00:00'
			// },
			// span: 12,
		},
		{
			label: '保险止期',
			prop: 'endDate',
			type: 'datetime',
			format: 'yyyy-MM-dd 23:59:59',
			valueFormat: 'yyyy-MM-dd 23:59:59',
			// formatter: (val) => {
			// 	return val.endDate + ' 23:59:59'
			// },
			// span: 12,
		},
		{
			//100:待核保；101：核保中；102:核保拒绝
			label: '状态',
			prop: 'status',
			width: 110,
			dicData: [
				{
					label: '退保',
					value: 0,
				},
				{
					label: '待支付',
					value: 1,
				},
				{
					label: '处理中',
					value: 2,
				},
				{
					label: '保障中',
					value: 3,
				},
				{
					label: '待起保',
					value: 3.5,
				},
				{
					label: '已取消',
					value: 4,
				},
				{
					label: '已到期',
					value: 5,
				},
				{
					label: '待核保',
					value: 100,
				},
				{
					label: '核保中',
					value: 101,
				},
				{
					label: '核保拒绝',
					value: 102,
				},
			],
		},
		//操作时间 createdTime
		{
			label: '操作时间',
			prop: 'createdTime',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
		},
		{
			label: '操作时间',
			prop: 'dateRange',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			defaultTime: ['00:00:00', '23:59:59'],
			hide: true,
			span: 12,
			searchRange: true,
			search: true,
			searchSpan: 12,
		},
	],
}
//  其他批改
export const processOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	menuAlign: 'center',
	align: 'center',
	searchMenuSpan: 6,
	searchBtn: false,
	searchShowBtn: true,
	searchShow: true,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	column: [
		{
			label: '申请时间',
			prop: 'createdAt',
		},
		{
			label: '生效时间',
			prop: 'effectiveDate',
		},
		{
			label: '类型',
			prop: 'applyTypeText',
		},
		{
			label: '状态',
			prop: 'statusText',
			width: 150,
		},
	],
}

//  处理中保单列表
export const policyProcessOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	align: 'center',
	searchShow: false,
	menuWidth: 180,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	excelBtn: true,
	column: [
		{
			label: '被保企业',
			prop: 'unitName',
			span: 12,
			fixed: true,
			search: false,
		},

		{
			label: '保单号',
			prop: 'policyNo',
			span: 12,
			fixed: true,
			search: false,
		},

		{
			label: '产品名称',
			prop: 'productTitle',
			span: 12,
		},

		{
			label: '申请类型',
			prop: 'applyTypeText',
			span: 12,
		},

		{
			label: '申请生效日期',
			prop: 'effectiveDate',
			span: 12,
		},

		{
			label: '状态',
			prop: 'statusText',
			slot: true,
			span: 12,
		},
	],
}

export const stagingListOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	align: 'center',
	searchMenuSpan: 6,
	searchBtn: false,
	searchShowBtn: true,
	searchShow: true,
	menuWidth: 180,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	excelBtn: true,
	column: [
		{
			label: '被保企业',
			prop: 'unitName',
			span: 12,
			fixed: true,
		},

		{
			label: '产品名称',
			prop: 'productName',
			span: 12,
		},

		{
			label: '保险起期',
			prop: 'effectiveDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},

		{
			label: '保险止期',
			prop: 'expiryDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},

		// {
		//   label: "状态",
		//   prop: "status",
		//   type: "select",
		//   dicData: [{
		//     label: '未完成',
		//     value: 0
		//   }, {
		//     label: '已完成',
		//     value: 1
		//   }],
		//   span: 12
		// },

		{
			label: '最后编辑时间',
			prop: 'updatedAt',
			// type: "datetime",
			// format: "yyyy-MM-dd HH:mm:ss",
			// valueFormat: "yyyy-MM-dd HH:mm:ss",
			span: 12,
		},
	],
}

//  该分销渠道所有保单列表（包含子渠道）
export const policyListAllOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	align: 'center',
	searchMenuSpan: 6,
	menuWidth: 160,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	excelBtn: true,
	showSummary: true,
	column: [
		{
			label: '产品名称',
			prop: 'insureTypes',
			display: false,
			type: 'select',
			dicData: getStore({name: 'insureTypes'}),
			props: {
				label: 'name',
				value: 'type',
			},
			hide: true,
			search: true,
		},
		{
			label: '被保企业',
			prop: 'insured',
			span: 12,
			fixed: true,
			search: true,
		},
		{
			label: '保单号',
			prop: 'policyNo',
			span: 12,
			hide: false,
			fixed: true,
			search: true,
		},
		{
			label: '产品名称',
			prop: 'productName',
			span: 12,
		},
		{
			label: '总保费(元)',
			prop: 'totalMoney',
			width: 120,
		},
		{
			label: '操作人',
			prop: 'distAccountName',
			width: 120,
		},
		{
			label: '出单渠道',
			prop: 'channelId',
			type: 'select',
			width: 120,
			dicData: [],
			props: {
				label: 'name',
				value: 'id',
			},
			formatter: ({distChannelName}) => {
				return distChannelName
			},
			span: 12,
			search: true,
		},
		{
			label: '保险起期',
			prop: 'startDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},
		{
			label: '保险止期',
			prop: 'endDate',
			type: 'datetime',
			format: 'yyyy-MM-dd',
			valueFormat: 'yyyy-MM-dd',
			formatter: (val) => {
				return val.endDate + ' 23:59:59'
			},
			span: 12,
		},
		{
			label: '状态',
			prop: 'status',
			width: 100,
			// formatter:({status,startDate})=>{
			//     switch (status){
			//         case 0:
			//             return '退保'
			//         case 1:
			//             return '待支付'
			//         case 2:
			//             return '处理中'
			//         case 3:
			//             //判断起保时间
			//             let result = startDate && new Date(startDate).getTime() - Date.now() > 0
			//             return result ? '待起保':'保障中'
			//         case 4:
			//             return '已取消'
			//         case 5:
			//             return '已到期'
			//     }
			// },
			dicData: [
				{
					label: '退保',
					value: 0,
				},
				{
					label: '待支付',
					value: 1,
				},
				{
					label: '处理中',
					value: 2,
				},
				{
					label: '保障中',
					value: 3,
				},
				{
					label: '待起保',
					value: 3.5,
				},
				{
					label: '已取消',
					value: 4,
				},
				{
					label: '已到期',
					value: 5,
				},
				{
					label: '待核保',
					value: 100,
				},
				{
					label: '核保中',
					value: 101,
				},
				{
					label: '核保拒绝',
					value: 102,
				},
			],
		},
		//操作时间 createdTime
		{
			label: '操作时间',
			prop: 'createdTime',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
		},
		{
			label: '操作时间',
			prop: 'dateRange',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			defaultTime: ['00:00:00', '23:59:59'],
			hide: true,
			span: 12,
			searchRange: true,
			search: true,
			searchSpan: 12,
		},
	],
}

/*
 *  保单详情页-details.vue
 */
//  保单详情投保人员列表
export const employeeTableOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	align: 'center',
	searchMenuSpan: 6,
	menuWidth: 140,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	excelBtn: false,
	excelBtnText: '下载人员清单',
	column: [
		{
			label: '姓名',
			prop: 'empName',
			span: 12,
			slot: true,
			search: true,
		},

		{
			label: '身份证',
			prop: 'empIdNo',
			span: 12,
			search: true,
		},

		// {
		//   label: "行业",
		//   prop: "professionCode",
		//   span: 12
		// },

		// {
		//   label: "分类",
		//   prop: "professionId",
		//   span: 12
		// },

		{
			label: '雇员类别',
			prop: 'profession',
			span: 12,
			formatter: ({profession = ''}) => {
				return profession ? profession : '--'
			},
		},
		{
			label: '是否涉高',
			prop: 'workType',
			span: 12,
			hide: false,
			formatter: ({workType = ''}) => {
				if (!workType) {
					return '--'
				}
				return `${workType}` === '1' ? '涉高' : '不涉高'
			},
		},
		{
			label: '保障额度',
			prop: 'insureMoney',
			slot: true,
			span: 12,
		},
		{
			label: '保费金额',
			prop: 'price',
		},
		{
			label: '保险起期',
			prop: 'effectiveDate',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},
		{
			label: '保险止期',
			prop: 'expiryDate',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},
	],
}

/*
 *  保单详情页-details.vue
 *  驾意险
 */
export const employeeTableOption_CAR = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	align: 'center',
	header: false,
	column: [],
}

//  批增记录
export const endorsementAddOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	menuAlign: 'center',
	align: 'center',
	searchMenuSpan: 6,
	menuWidth: 180,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	rowKey: 'payOrderId',
	column: [
		{
			label: '变更时间',
			prop: 'createTime',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},

		{
			label: '生效时间',
			prop: 'effectiveDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},

		// 101 - 批增，102 - 批改
		{
			label: '变更类型',
			prop: 'changeCode',
			span: 12,
			hide: true,
			dicData: [
				{
					label: '新增',
					value: 101,
				},
				{
					label: '替换',
					value: 102,
				},
			],
		},

		{
			label: '明细',
			prop: 'details',
			span: 12,
		},

		{
			label: '支付保费',
			prop: 'payMoney',
			formatter: (row, value, label, column) => {
				return (label = parseFloat(value / 100).toFixed(2) + '元')
			},
			span: 12,
		},

		{
			label: '状态',
			prop: 'status',
			dicData: [
				{
					label: '已退保',
					value: 0,
				},
				{
					label: '待支付',
					value: 1,
				},
				{
					label: '处理中',
					value: 2,
				},
				{
					label: '成功',
					value: 3,
				},
				{
					label: '超时取消',
					value: 4,
				},
				{
					label: '已撤销',
					value: 8,
				},
			],
			span: 12,
		},
	],
}
//  批改记录
export const endorsementChangeOption = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	align: 'center',
	menuAlign: 'center',
	menuWidth: 120,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	search: false,
	column: [
		{
			label: '变更时间',
			prop: 'createTime',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},

		{
			label: '生效时间',
			prop: 'effectiveDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},

		// 101 - 批增，102 - 批改
		{
			label: '变更类型',
			prop: 'changeCode',
			span: 12,
			hide: true,
			dicData: [
				{
					label: '新增',
					value: 101,
				},
				{
					label: '替换',
					value: 102,
				},
			],
		},

		{
			label: '被替换雇员',
			prop: 'employeeOld',
			span: 12,
		},

		{
			label: '新雇员',
			prop: 'employeeNew',
			span: 12,
		},

		{
			label: '状态',
			prop: 'status',
			dicData: [
				{
					label: '已退保',
					value: 0,
				},
				{
					label: '待支付',
					value: 1,
				},
				{
					label: '处理中',
					value: 2,
				},
				{
					label: '成功',
					value: 3,
				},
				{
					label: '超时取消',
					value: 4,
				},
				{
					label: '已撤销',
					value: 8,
				},
			],
			span: 12,
		},
	],
}
//  批增人员清单
export const endorsementDetailsOption = {
	border: true,
	index: true,
	indexLabel: '序号',
	header: false,
	stripe: true,
	align: 'center',
	menu: false,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	columnBtn: false,
	refreshBtn: false,
	saveBtn: false,
	updateBtn: false,
	cancelBtn: false,

	column: [
		{
			label: '姓名',
			prop: 'empName',
			span: 12,
			fixed: true,
		},

		{
			label: '身份证',
			prop: 'empIdNo',
			span: 12,
			fixed: true,
		},

		{
			label: '行业',
			prop: 'industry',
			span: 12,
		},

		{
			label: '分类',
			prop: 'type',
			span: 12,
		},

		{
			label: '工种',
			prop: 'categoryName',
			span: 12,
		},

		{
			label: '保险起期',
			prop: 'effectiveDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},

		{
			label: '保险止期',
			prop: 'expiryDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			span: 12,
		},
	],
}

/*
 *  保单录入页-entry.vue
 */
export const optionRepeatEmployee = {
	border: true,
	index: true,
	indexLabel: '序号',
	stripe: true,
	align: 'center',
	menu: false,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	search: false,
	columnBtn: false,
	refreshBtn: false,
	saveBtn: false,
	updateBtn: false,
	cancelBtn: false,
	column: [
		{
			label: '姓名',
			prop: 'empName',
		},
		{
			label: '身份证',
			prop: 'empIdNo',
		},
		{
			label: '被保企业',
			prop: 'unitName',
		},
		{
			label: '保障中保单号',
			prop: 'policyNo',
		},
		{
			label: '保险止期',
			prop: 'expiryDate',
		},
	],
}

export const optionEmployee = {
	index: true,
	indexLabel: '序号',
	indexWidth: 80,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	refreshBtn: false,
	columnBtn: false,
	addRowBtn: true,
	cellBtn: true,
	saveBtn: false,
	cancelBtnText: '移除',
	menu: true,
	align: 'center',
	column: [
		{
			label: '姓名',
			prop: 'name',
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身份证',
			prop: 'idNo',
			class: 'idNo',
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 身份证号',
					trigger: 'blur',
				},
				{
					required: true,
					validator: rule.validatorIdNo,
					trigger: 'blur',
				},
			],
		},
		{
			label: '雇员类别',
			prop: 'profession',
			hide: false,
			slot: true,
			rules: [
				{
					required: true,
					message: '请选择 职业',
					trigger: 'blur',
				},
			],
		},
		{
			label: '雇员类别',
			prop: 'professionTemp',
			hide: true,
		},
		//"feeRate":0代表不涉高 1 涉高
		{
			label: '是否涉高',
			prop: 'feeRate',
			slot: true,
			hide: true,
			// cell: true,
			// dicData: [
			//   {
			//     label: '不涉高',
			//     value: '0'
			//   }, {
			//     label: '涉高',
			//     value: '1'
			//   }
			// ],
			// rules: [
			//   {
			//     required: true,
			//     message: '请选择 是否涉高',
			//     trigger: 'blur'
			//   }
			// ]
		},
		{
			label: '保费',
			prop: 'premium',
			width: 100,
			value: 0,
			formatter: ({premium = 0}) => {
				return `${premium}元`
			},
		},
	],
}

export const optionEmployee_NoProfession = {
	index: true,
	indexLabel: '序号',
	addBtn: false,
	editBtn: false,
	delBtn: false,
	refreshBtn: false,
	columnBtn: false,
	addRowBtn: true,
	cellBtn: true,
	saveBtn: false,
	cancelBtnText: '移除',
	menu: true,
	column: [
		{
			label: '姓名',
			prop: 'name',
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身份证',
			prop: 'idNo',
			class: 'idNo',
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 身份证号',
					trigger: 'blur',
				},
				{
					required: true,
					validator: rule.validatorIdNo,
					trigger: 'blur',
				},
			],
		},
		// {
		//   label: '雇员类别',
		//   prop: 'profession',
		//   slot: true,
		//   rules: [
		//     {
		//         required: true,
		//         message: '请选择 职业',
		//         trigger: 'blur'
		//     }
		//   ]
		// },
		{
			label: '保费',
			prop: 'premium',
			value: 0,
			formatter: ({premium = 0}) => {
				return `${premium}元`
			},
		},
	],
}

// export const optionEmployeeView_45 = {
//   index: true,
//   indexLabel: "序号",
//   addBtn: false,
//   editBtn: false,
//   delBtn: false,
//   refreshBtn: false,
//   columnBtn: false,
//   addRowBtn: false,
//   cellBtn: false,
//   saveBtn: false,
//   menu: false,
//   column: [
//     {
//       label:'姓名',
//       prop: 'name',
//       width: 120,
//     },
//     {
//       label: '身份证',
//       prop: 'idNo',
//       width: 180,
//     },
//     {
//       label: '雇员类别',
//       prop: 'profession',
//       slot: true
//     },
//     {
//       label: '保费',
//       prop: 'premium',
//       width: 120,
//       value: 0,
//       slot: true
//     },
//   ]
// }

export const optionEmployeeView = {
	index: true,
	indexLabel: '序号',
	border: true,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	refreshBtn: false,
	columnBtn: false,
	addRowBtn: false,
	cellBtn: false,
	saveBtn: false,
	menu: false,
	column: [
		{
			label: '姓名',
			prop: 'name',
			width: 120,
		},
		{
			label: '身份证',
			prop: 'idNo',
			width: 240,
		},
		{
			label: '雇员类别',
			prop: 'profession',
			slot: true,
		},
		{
			label: '保额',
			prop: 'coverage',
			width: 120,
			slot: true,
		},
		{
			label: '保费',
			prop: 'premium',
			width: 120,
			value: 0,
			hide: false,
			formatter: ({premium = 0}) => {
				return `${premium}元`
			},
		},
		{
			label: '备注',
			prop: 'remark',
			width: 120,
			slot: true,
		},
	],
}

export const optionEmployeeView_NoProfession = {
	index: true,
	indexLabel: '序号',
	indexWidth: 80,
	border: true,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	refreshBtn: false,
	columnBtn: false,
	addRowBtn: false,
	cellBtn: false,
	saveBtn: false,
	align: 'center',
	menu: false,
	column: [
		{
			label: '姓名',
			prop: 'name',
		},
		{
			label: '身份证',
			prop: 'idNo',
		},
		{
			label: '保费',
			prop: 'premium',
			value: 0,
			formatter: ({premium = 0}) => {
				return `${premium}元`
			},
		},
		{
			label: '备注',
			prop: 'remark',
			value: '',
			slot: true,
		},
	],
}

//阳光车意险 投保页
export const optionEmployeeView_car_14 = {
	index: true,
	indexLabel: '序号',
	border: true,
	addBtn: false,
	header: false,
	excelBtn: true,
	align: 'center',
	menu: false,
	column: [
		{
			label: '车牌号',
			prop: 'licenseNo',
		},
		{
			label: '车架号',
			prop: 'vin',
		},
		{
			label: '投保座位数',
			prop: 'insureSeatNum',
		},
		{
			label: '核定座位数',
			prop: 'seatNum',
		},
		{
			label: '发动机号',
			prop: 'engineNo',
		},
		{
			label: '总保费(元)',
			prop: 'premium',
			formatter: ({premium = 0, price = 0}) => {
				if (premium === 0) {
					return `${price / 100}元`
				}
				return `${premium}元`
			},
		},
	],
}

//阳光车意险 详情页
export const optionEmployeeView_detail_car_14 = {
	index: true,
	indexLabel: '序号',
	border: true,
	addBtn: false,
	header: false,
	excelBtn: true,
	align: 'center',
	menu: false,
	column: [
		{
			label: '车牌号',
			prop: 'licenseNo',
		},
		{
			label: '车架号',
			prop: 'vin',
		},
		{
			label: '投保座位数',
			prop: 'insureSeatNum',
		},
		{
			label: '核定座位数',
			prop: 'seatNum',
		},
		{
			label: '发动机号',
			prop: 'engineNo',
		},
		{
			label: '保障额度',
			prop: 'insureMoney',
			formatter: ({insureMoney}) => {
				return `${insureMoney}万`
			},
		},
		{
			label: '保险起期',
			prop: 'effectiveDate',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
		},
		{
			label: '保险止期',
			prop: 'expiryDate',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
		},
		{
			label: '总保费(元)',
			prop: 'price',
		},
	],
}

export const optionEmployeeRepeat = {
	index: false,
	indexLabel: '序号',
	header: false,
	menu: false,
	align: 'center',
	border: true,
	column: [
		{
			label: '姓名',
			prop: 'empName',
		},
		{
			label: '身份证',
			prop: 'empIdNo',
		},
		{
			label: '保障中的保单号',
			prop: 'policyNo',
		},
		{
			label: '保障止期',
			prop: 'expiryDate',
		},
		{
			label: '最早可选生效日期',
			prop: 'effectiveDateEarliest',
		},
	],
}

//  批改并确认结果
export const optionEmployeeResult = {
	card: true,
	border: true,
	index: true,
	indexLabel: '序号',
	addBtn: false,
	editBtn: false,
	delBtn: false,
	refreshBtn: false,
	columnBtn: false,
	addRowBtn: false,
	cellBtn: false,
	saveBtn: false,
	menu: false,
	stripe: true,
	tip: true,
	menuAlign: 'center',
	align: 'center',
	menuWidth: 120,
	column: [
		{
			label: '原雇员',
			prop: 'nameReplaced',
		},
		{
			label: '原雇员身份证',
			prop: 'idNoReplaced',
		},
		{
			label: '新雇员',
			prop: 'nameNew',
		},
		{
			label: '新雇员身份证',
			prop: 'idNoNew',
		},
		{
			label: '雇员类别',
			prop: 'profession',
		},
		{
			label: '实际生效时间',
			prop: 'effectiveDate',
		},
		{
			label: '状态',
			prop: 'status',
			slot: true,
			html: true,
			formatter: (val) => {
				let resultColor = ''
				let content = ''
				let loading = ''
				switch (val.status) {
					case '100':
						resultColor = '#409eff'
						content = '处理中'
						loading = `<i class="el-icon-loading" style="margin-right: 5px"></i>`
						break
					case '200':
						resultColor = 'green'
						content = '成功'
						break
					case '400':
						resultColor = 'red'
						content = '替换失败'
						break
				}
				return `${loading}<span style="color:${resultColor}">${content}</span>`
			},
			dicData: [
				{
					label: '处理中',
					value: '100',
				},
				{
					label: '成功',
					value: '200',
				},
				{
					label: '替换失败',
					value: '400',
				},
			],
		},
		{
			label: '备注',
			prop: 'remark',
		},
	],
}

//  批改新旧替换
export const optionEmployeeReplace = {
	border: true,
	index: true,
	indexLabel: '序号',
	header: false,
	addBtn: false,
	editBtn: false,
	delBtn: true,
	refreshBtn: false,
	columnBtn: false,
	// addRowBtn: false,
	cellBtn: false,
	// saveBtn: false,
	// cancelBtnText: '移除',
	menu: true,
	// stripe: true,
	tip: true,
	align: 'center',
	menuAlign: 'center',
	menuWidth: 120,
	column: [
		{
			label: '原雇员',
			prop: 'nameReplaced',
		},
		{
			label: '原雇员身份证',
			prop: 'idNoReplaced',
		},
		{
			label: '雇员类别',
			prop: 'profession',
		},
		{
			label: '新雇员',
			prop: 'nameNew',
			cell: true,
			rules: [
				{
					required: true,
					message: '请填写 新雇员姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '新雇员身份证',
			prop: 'idNoNew',
			cell: true,
			rules: [
				{
					required: true,
					validator: rule.validatorIdNo,
					trigger: ['blur', 'change'],
				},
			],
		},
	],
}

//  批改待替换人员
export const optionEmployeeEndorse = {
	border: true,
	selection: true,
	reserveSelection: true,
	index: true,
	indexLabel: '序号',
	addBtn: false,
	editBtn: false,
	delBtn: false,
	searchShowBtn: false,
	refreshBtn: false,
	columnBtn: false,
	addRowBtn: false,
	cellBtn: false,
	saveBtn: false,
	menu: true,
	stripe: true,
	gridBtn: false,
	menuAlign: 'center',
	align: 'center',
	searchMenuSpan: 6,
	menuWidth: 120,
	column: [
		{
			label: '姓名',
			prop: 'empName',
			search: true,
		},
		{
			label: '身份证',
			prop: 'empIdNo',
			search: true,
		},
		{
			label: '雇员类别',
			prop: 'profession',
			slot: true,
		},
		{
			label: '保险起期',
			prop: 'effectiveDate',
			span: 12,
		},
		{
			label: '保险止期',
			prop: 'expiryDate',
			span: 12,
		},
		{
			label: '保障额度',
			prop: 'insureSum',
			slot: true,
		},
	],
}
// 开具发票
// export const optionInvoice = {
//   submitBtn: true,
//   submitText: '确认',
//   emptyBtn: false,
//   menuBtn: true,
//   labelWidth: '25%',
//   column: [
//     {
//       label: '开票类型',
//       prop: 'type',
//       span: 12,
//       type: 'select',
//       dicData: [
//         {
//           label: '增值税普票',
//           value: 2
//         },
//         {
//           label: '增值税专票',
//           value: 1
//         }
//       ],
//       rules: [
//         {
//             required: true,
//             message: '请选择开票类型',
//             trigger: 'change'
//         }
//       ]
//     },
//     {
//       label: '开票金额',
//       prop: 'amount',
//       span: 12,
//       placeholder: ' ',
//       disabled: true,
//     },
//     {
//       label: '纳税人识别号',
//       prop: 'identification',
//       placeholder: '请填写 纳税人识别号',
//       span: 12,
//       rules: [
//         {
//             required: true,
//             validator: rule.validatorCreditCode,
//             trigger: 'blur'
//         }
//       ]
//     },
//     {
//       label: '发票抬头',
//       prop: 'title',
//       span: 12,
//       placeholder: ' ',
//       disabled: true,
//     }
//   ],
//   group: [{
//     display: false,
//     arrow: false,
//     column: [
//       {
//         label: '注册地址',
//         prop: 'address',
//         placeholder: '请填写 税务登记详细地址'
//       },
//       {
//         label: '注册电话',
//         prop: 'phone',
//         placeholder: '请填写 税务登记联系电话'
//       },
//       {
//         label: '开户银行',
//         prop: 'bankName',
//         placeholder: '请填写 税务登记开户银行'
//       },
//       {
//         label: '开户账号',
//         prop: 'bankNo',
//         placeholder: '请填写 税务登记开户行账号'
//       },
//       {
//         label: '收件人',
//         prop: 'mailName',
//         placeholder: '请填写 收件人姓名'
//       },
//       {
//         label: '手机号',
//         prop: 'mailPhone',
//         placeholder: '请填写 收件人手机号',
//         rules: [
//           {
//             validator: rule.validatorMobile,
//             trigger:'blur'
//           }
//         ]
//       },
//       {
//         label: '收件人地址',
//         type: 'cascader',
//         prop: 'mailAreaCode',
//         props: {
//             label: 'areaName',
//             value: 'areaCode'
//         },
//         dicUrl: `/dist/area/list/3`,
//         dicMethod: 'get',
//         filterable: true,
//         showAllLevels: true
//       },
//       {
//         label: '',
//         prop: 'mailAddress',
//         placeholder: '请填写 收件人详细地址'
//       },
//       {
//         label: '纳税人资质证明',
//         type: 'upload',
//         prop: 'taxCertificate',
//         span: 12,
//         listType: 'picture-img',
//         action: '/dist/distInsure/uploadFile',
//         propsHttp: {
//           res: 'data'
//         }
//       },
//       {
//         label: '示例',
//         prop: 'example1',
//         type: 'upload',
//         span: 3,
//         listType: 'picture-img',
//         propsHttp: {
//             res: 'data'
//         },
//         disabled: true
//       },
//       {
//         label: '',
//         prop: 'example2',
//         type: 'upload',
//         span: 3,
//         listType: 'picture-img',
//         propsHttp: {
//             res: 'data'
//         },
//         disabled: true
//       },
//     ]
//   }]
// }
export const optionPayOffline = {
	submitBtn: true,
	submitText: '立即提交',
	emptyBtn: false,
	labelWidth: '25%',
	column: [
		{
			label: '账户名',
			prop: 'accountName',
			span: 24,
			disabled: true,
		},
		{
			label: '开户行',
			prop: 'accountOpening',
			span: 24,
			disabled: true,
		},
		{
			label: '账号',
			prop: 'account',
			span: 24,
			disabled: true,
		},
		{
			label: '转账时间',
			prop: 'transferTime',
			span: 24,
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			pickerOptions: {
				disabledDate: (time) => {
					return time.getTime() > Date.now()
				},
			},
			rules: [
				{
					required: true,
					message: '请输入 转账时间',
					trigger: 'blur',
				},
			],
		},
		{
			label: '转账凭证',
			prop: 'certificate',
			span: 16,
			slot: true,
		},
		{
			label: '示例',
			prop: 'example',
			value: 'images/yyzz_sl1.png',
			type: 'upload',
			listType: 'picture-img',
			span: 8,
			propsHttp: {
				res: 'data',
			},
			disabled: true,
		},
	],
}

/**
 * 退保资料
 */
export const optionSurrenderPayee = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	labelWidth: '25%',
	column: [
		{
			label: '账户类型',
			prop: 'payAccountTypeText',
			disabled: true,
		},
		{
			label: '收款人户名',
			prop: 'payeeName',
			rules: [
				{
					required: true,
					message: '请输入 收款人户名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '收款人身份证号',
			prop: 'authIdCard',
			display: false,
			rules: [
				{
					required: true,
					message: '请输入 收款人身份证号',
					trigger: 'blur',
				},
				{
					required: true,
					validator: rule.validatorIdNo,
					message: '请输入 正确的身份证号',
				},
			],
		},
		{
			label: '收款银行(卡)账号',
			prop: 'bankNo',
			rules: [
				{
					required: true,
					message: '请输入 收款银行(卡)账号',
					trigger: 'blur',
				},
			],
		},
		{
			label: '开户银行联行号',
			prop: 'bankNumber',
			display: false,
			rules: [
				{
					required: true,
					message: '请输入 开户银行联行号',
					trigger: 'blur',
				},
			],
		},
		{
			label: '收款开户行及支行',
			prop: 'bankName',
			rules: [
				{
					required: true,
					message: '请选择 收款开户行及支行',
					trigger: 'blur',
				},
			],
			formslot: true,
		},
		{
			label: '收款银行所属省市',
			type: 'cascader',
			prop: 'bankCityCode',
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicUrl: '/dist/area/list/2',
			emitPath: false,
			filterable: true,
			showAllLevels: true,
			rules: [
				{
					required: true,
					message: '请选择 收款银行所属省市',
					trigger: 'change',
				},
			],
		},
		{
			label: '授权退款原因',
			prop: 'authReasonText',
			display: false,
			disabled: true,
		},
	],
}

export const optionExpress = {
	submitBtn: true,
	submitText: '确认',
	emptyBtn: false,
	menuBtn: true,
	column: [
		{
			label: '快递公司',
			prop: 'company',
			type: 'select',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择 快递公司',
					trigger: 'change',
				},
			],
		},
		{
			label: '快递单号',
			prop: 'trackingNumber',
			span: 24,
			rules: [
				{
					required: true,
					message: '请输入 快递单号',
					trigger: 'blur',
				},
			],
		},
	],
}

export const optionCar = {
	index: true,
	indexLabel: '序号',
	header: false,
	align: 'center',
	menu: false,
	border: true,
	stripe: true,
	column: [
		{
			label: '车牌号',
			prop: 'licenseNo',
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 车牌号',
					trigger: 'blur',
				},
				{
					required: true,
					trigger: 'blur',
					validator: rule.validatorCar,
				},
			],
		},
		{
			label: '车架号',
			prop: 'vin',
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 车架号',
					trigger: 'blur',
				},
				{
					required: true,
					validator: (rule, value, callback) => {
						if (value.length !== 17) {
							callback(new Error('请输入正确的车架号'))
						} else {
							callback()
						}
					},
					trigger: 'blur',
				},
			],
		},
		{
			label: '投保座位数',
			prop: 'insureSeatNum',
			cell: true,
			type: 'select',
			rules: [
				{
					required: true,
					message: '请选择 投保座位数',
					trigger: 'blur',
				},
			],
			dicData: [
				{
					label: '3座及以下',
					value: 3,
				},
				{
					label: '4座',
					value: 4,
				},
				{
					label: '5座',
					value: 5,
				},
			],
		},
		{
			label: '核定座位数',
			prop: 'seatNum',
			cell: true,
			type: 'select',
			rules: [
				{
					required: true,
					message: '请选择 核定座位数',
					trigger: 'blur',
				},
			],
			dicData: [
				{
					label: '3座及以下',
					value: 3,
				},
				{
					label: '4座',
					value: 4,
				},
				{
					label: '5座',
					value: 5,
				},
			],
		},
		{
			label: '发动机号',
			prop: 'engineNo',
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 发动机号',
					trigger: 'blur',
				},
			],
		},
		{
			label: '总保费(元)',
			prop: 'premium',
			value: 0,
			formatter: ({premium = 0}) => {
				return `${premium}元`
			},
		},
	],
}

export const optionCarRepeat = {
	header: false,
	border: true,
	menu: false,
	align: 'center',
	column: [
		{
			label: '保单号',
			prop: 'policyNo',
		},
		{
			label: '车牌号',
			prop: 'licenseNo',
			width: 120,
		},
		{
			label: '车架号',
			prop: 'vin',
		},
		{
			label: '投保座位数',
			prop: 'insureSeatNum',
			width: 120,
		},
		{
			label: '核定座位数',
			prop: 'seatNum',
			width: 120,
		},
		{
			label: '发动机号',
			prop: 'engineNo',
		},
		{
			label: '生效日期',
			prop: 'effectiveDate',
			formatter: ({effectiveDate}) => {
				return effectiveDate ? `${effectiveDate} 00:00:00` : '--'
			},
		},
		{
			label: '失效日期',
			prop: 'expiryDate',
			formatter: ({expiryDate}) => {
				return expiryDate ? `${expiryDate} 23:59:59` : '--'
			},
		},
	],
}

//家电共同被保险人
export const option_insured_form = {
	index: true,
	indexWidth: 100,
	indexLabel: '序号',
	header: false,
	border: true,
	cancelBtnText: '移除',
	menu: true,
	align: 'center',
	column: [
		{
			label: '企业名称',
			prop: 'unit_name',
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '统一信用代码',
			prop: 'unit_code',
		},
	],
}

export const option_insured_form_new = {
	index: true,
	indexWidth: 100,
	indexLabel: '序号',
	header: false,
	border: true,
	cancelBtnText: '移除',
	editBtn: false,
	menu: true,
	menuWidth: 180,
	align: 'center',
	column: [
		{
			label: '企业名称',
			prop: 'name',
		},
		{
			label: '统一信用代码',
			prop: 'certNo',
		},
		{
			label: '联系人',
			prop: 'legalPerson',
		},
		{
			label: '手机号码',
			prop: 'legalPersonMobile',
		},
	],
}

//红包列表
export const option_redpack_list = (safe) => {
	return {
		border: true,
		stripe: true,
		menu: false,
		addBtn: false,
		excelBtn: true,
		align: 'center',
		labelWidth: 120,
		searchLabelWidth: 120,
		searchMenuSpan: 10,
		column: [
			{
				label: '主渠道',
				prop: 'mainChannelName',
				hide: true,
				search: true,
				formatter: ({mainChannel = {}}) => {
					let {name = ''} = mainChannel
					return name
				},
			},
			{
				label: '操作人',
				prop: 'channelName',
				hide: true,
				search: true,
				formatter: ({channel = {}}) => {
					let {name = ''} = channel
					return name
				},
			},
			{
				label: '登录账号',
				prop: 'accountLoginName',
				hide: true,
				search: true,
				formatter: ({account = {}}) => {
					let {loginName = ''} = account
					return loginName
				},
			},
			{
				label: '产品名称',
				prop: 'orderInsureType',
				search: true,
				type: 'select',
				dicData: getStore({name: 'insureTypes'}),
				props: {
					label: 'name',
					value: 'type',
				},
			},
			{
				label: '保单号',
				prop: 'orderPolicyNo',
				search: true,
				searchOrder: 0,
				formatter: ({order = {}}) => {
					let {policyNo = ''} = order
					return policyNo
				},
			},
			{
				label: '投保企业',
				prop: 'unitName',
				search: true,
				searchOrder: 0,
				formatter: ({order = {}}) => {
					let {unitName = ''} = order
					return unitName
				},
			},
			{
				label: '信用代码',
				prop: 'unitCode',
				search: true,
				searchOrder: 0,
				formatter: ({order = {}}) => {
					let {unitCode = ''} = order
					return unitCode
				},
			},
			{
				label: '保单金额',
				prop: 'orderAmount',
				formatter: ({order = {}}) => {
					let {payMoney = ''} = order
					return `${payMoney / 100}元`
				},
			},
			{
				label: '业务跟进人',
				prop: 'mainChannelFollowId',
				type: 'select',
				search: true,
				props: {
					label: 'name',
					value: 'id',
				},
				dicUrl: '/dist/distChannel/listContact',
			},
			{
				label: '红包名称',
				prop: 'actName',
			},
			{
				label: '红包类型',
				prop: 'redpackType',
				//repurchase复购，expired脱保，renewal续保
				type: 'select',
				search: true,
				bind: 'order.redpackType',
				dicData: [
					{
						label: '复购',
						value: 'repurchase',
					},
					{
						label: '脱保',
						value: 'expired',
					},
					{
						label: '续保',
						value: 'renewal',
					},
				],
			},
			{
				label: '红包金额',
				prop: 'totalAmount',
				width: 100,
				formatter: ({totalAmount = 0}) => {
					return totalAmount / 100 + '元'
				},
			},
			{
				label: '领取时间',
				prop: 'rcvTime',
			},
			{
				label: 'openid',
				prop: 'openid',
			},
			{
				label: 'unionid',
				prop: 'unionid',
			},
			{
				label: '状态',
				prop: 'status',
				formatter: ({status = ''}) => {
					return status === 'RECEIVED' ? '已领取' : '未领取'
				},
			},
		],
	}
}

export const policyCheckOption = (safe) => {
	return {
		border: true,
		stripe: true,
		addBtn: false,
		excelBtn: true,
		align: 'center',
		labelWidth: 100,
		editBtn: false,
		delBtn: false,
		showSummary: true,
		column: [
			{
				label: '被保企业',
				prop: 'unitName',
				search: true,
			},
			{
				label: '信用代码',
				prop: 'unitCode',
				search: true,
			},
			{
				label: '保单号',
				prop: 'policyNo',
				search: true,
			},
			{
				label: '批单号',
				prop: 'changePolicyNo',
				search: true,
				formatter: ({changePolicyNo = ''}) => {
					return changePolicyNo ? changePolicyNo : '--'
				},
			},
			{
				label: '类型',
				prop: 'changeCode',
				search: true,
				type: 'select',
				width: 100,
				dicData: changeCodeDicEndorseData,
				formatter: ({changeCodeText = ''}) => {
					return changeCodeText || '--'
				},
			},
			{
				label: '保费(元)',
				prop: 'payMoney',
				width: 100,
				formatter: ({totalMoney = '', payMoney}) => {
					return payMoney || totalMoney || 0
				},
			},
			// {
			//   label: '状态',
			//   prop: 'status',
			//   type: 'select',
			//   search: true,
			//   width: 80,
			//   dicData: [
			//     {
			//       label: '已完成',
			//       value: 3,
			//     }, {
			//       label: '处理中',
			//       value: 1,
			//     }, {
			//       label: '已取消',
			//       value: 8,
			//     },
			//   ],
			//   formatter: ({statusText = ''}) => {
			//     return statusText || '--'
			//   },
			// },
			{
				label: '创建时间',
				prop: 'createTime',
			},
		],
	}
}

export const gaiZhangOption = (safe) => {
	return {
		border: true,
		stripe: true,
		addBtn: false,
		excelBtn: false,
		align: 'center',
		menuWidth: 160,
		searchMenuSpan: 12,
		editBtn: false,
		searchMenuPosition: 'right',
		delBtn: false,
		column: [
			{
				label: '方案ID',
				prop: 'productId',
				width: 100,
			},
			{
				label: '产品名称',
				prop: 'sourceProductId',
				type: 'select',
				dicUrl: `/dist/distProduct/listInfo`,
				props: {
					label: 'title',
					value: 'id',
				},
				hide: true,
			},
			{
				label: '产品名称',
				prop: 'pubName',
			},
			{
				label: '方案名称',
				prop: 'sourceProductTitle',
				type: 'select',
			},
			{
				label: '链接地址',
				prop: 'insureDeclareImg',
			},
			{
				label: '创建时间',
				prop: 'insureDeclareSignDate',
				width: 160,
			},
		],
	}
}
